import { EditEventButtonActionStates } from './EditEventButtonsBar.types';
import { StepButtonsConfig } from 'components/ButtonsBar/ButtonsBar';
import { useYodaForm } from 'yoda-ui/yodaForm';

type EditEventButtonsBarHookParams = {
  config: StepButtonsConfig | null;
  actionStates: EditEventButtonActionStates;
};

const useEditEventButtonsBar = (
  { config, actionStates }: EditEventButtonsBarHookParams,
): StepButtonsConfig | null => {
  const { useWatchForm } = useYodaForm();
  const { isDirty } = useWatchForm();
  const { updateLoading, publishLoading, readyToPublish, isLastStep } = actionStates;

  if (!config) {
    return null;
  }

  const result: StepButtonsConfig = { ...config };

  if (result.firstButton) {
    result.firstButton = {
      ...result.firstButton,
      buttonProps: { ...result.firstButton.buttonProps, disabled: updateLoading },
      loading: updateLoading,
    };
  }

  if (result.secondButton) {
    result.secondButton = {
      ...result.secondButton,
      buttonProps: { ...result.secondButton.buttonProps, disabled: updateLoading || !isDirty },
      loading: updateLoading,
    };
  }

  if (result.thirdButton) {
    result.thirdButton = {
      ...result.thirdButton,
      buttonProps: {
        ...result.thirdButton.buttonProps,
        disabled: isLastStep ? !readyToPublish : updateLoading,
      },
      loading: isLastStep ? publishLoading : updateLoading,
    };
  }

  return result;
};

export default useEditEventButtonsBar;
